<template>
  <div class="gap-12px px-12px pt-8px pb-2px relative flex bg-[#fff]">
    <div
      v-for="(item, index) in data"
      :key="item.label"
      class="report-statistics-item"
      :class="`bg-` + ((index < BG_MAX_NUM ? index : index - BG_MAX_NUM) + 1)"
    >
      <div class="text-[#6F7680]">{{ item.label }}</div>
      <div class="text-24px font-600">{{ item.value ?? '-' }}{{ item.suffix }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { Option } from '@mts-fe/types';

  export type StatisticsItem = { suffix?: string } & Option;

  defineProps<{
    data: StatisticsItem[];
  }>();

  const BG_MAX_NUM = 7;
</script>

<style lang="less">
  .report-statistics-item {
    flex: 1;
    max-width: 360px;
    padding: 12px 16px;
    border-radius: 4px;
    font-size: 14px;
  }

  @colorMap: {
    1: radial-gradient(circle at 100% -23%, #f4fef3 0%, #d6f6de 182%);
    2: radial-gradient(circle at 100% -23%, #f5fcff 0%, #ddf0fe 182%);
    3: radial-gradient(circle at 100% -23%, #f8f9ff 0%, #ebeeff 182%);
    4: radial-gradient(circle at 100% -23%, #f4fefd 0%, #e0fbfd 182%);
    5: radial-gradient(circle at 100% -23%, #fffcff 0%, #fdf2ff 182%);
    6: radial-gradient(circle at 100% -23%, #fef8f8 0%, #fff0f0 202%);
    7: radial-gradient(circle at 100% -23%, #fffaf0 0%, #fdf5e0 181%);
  };
  each(@colorMap, {
    .report-statistics-item.bg-@{key}{
        background-image: @value;
      }
    });
</style>
